import { Base, StrictBase, TypeOrmFindManyOptions } from '@wilson/base';
import { Currency } from '@wilson/localization';
import { BillingRules } from './billing-rules';
import { Client } from './client';

export enum ProductUnit {
  Hours = 'hours',
  Meters = 'meters',
  Days = 'days',
  Pieces = 'pieces',
}

export enum ProductType {
  ActivityBased = 'activityBased',
  Booked = 'booked',
}

export interface AgreementProducts {
  agreementId: string;
  productId: string;
  quantity: number;
  product: ProductDTO;
}

export interface ProductDTO extends StrictBase {
  name: string;
  shortName: string | null;
  volume: number;
  unit: ProductUnit;
  rules: string;
  organizationalUnitId: string;
  operativeSelectable?: boolean;
  type?: ProductType;
}
export type AgreementId = string;

export interface ProductDTOPayload extends StrictBase {
  name: string;
  shortName?: string | null;
  volume?: number;
  unit?: ProductUnit;
  rules?: Rule[];
  organizationalUnitId?: string;
}

export interface CreateProductDTO {
  name: string;
  shortName?: string;
  volume?: number;
  unit?: ProductUnit;
  rules?: BillingRules[];
}

export type AgreementDTOPayload = Omit<Agreement, 'agreementProducts'>;

export const NO_AGREEMENT = 'no-agreement';

export enum AgreementStatus {
  Open = 'open',
  Active = 'active',
  Closed = 'closed',
}

export interface Agreement extends Base {
  name: string;
  status: AgreementStatus;
  volume: number;
  orderNumber: string;
  externalIdentifier: string;
  description: string | null;
  clientId: string;
  client?: Client;
  advancePayment: string | number | null;
  companyCode: string | null;
  currency: Currency;
  organizationalUnitId?: string;
  purchaseOrder: string | null;
  vat: string | number | null;
  costCenter: string | null;
  agreementProducts: AgreementProducts[];
}

export interface Rule {
  ruleName: string;
  calculatorName: string;
  params: RuleParams;
}
export interface RuleParams {
  minimumAmount: number;
  pricePerUnit: number;
}

export interface TypeOrmFindManyOptionsWithAgreements
  extends TypeOrmFindManyOptions {
  agreementIds?: string[];
}
export interface AggregatedAgreementKPIs {
  totalReportedDurationInMinutes: number;
  totalBilledReportedDurationInMinutes: number;
}

export type AgreementKPIsResponse = Record<
  AgreementId,
  AggregatedAgreementKPIs
>;

export type AgreementWithBillingRules = Agreement & {
  rules: BillingRules[];
};
